export default class ItemEventReplyDomainService {
    static fromJSON(json) {
        // @ts-expect-error - TS2739 - Type '{ createdDate: Date; editedDate: any; deletedDate: any; }' is missing the following properties from type 'ItemEventReply': id, createdBy, text, deletable, editable
        return Object.assign(Object.assign({}, json), { createdDate: new Date(json.createdDate), editedDate: json.editedDate && new Date(json.editedDate), deletedDate: json.deletedDate && new Date(json.deletedDate) });
    }
}
